export default __webpack_public_path__ + "static/unicornmetalics-logo-20a4603a685ecb2e5cb1cc54f86ef7e9.png";